import React, { FunctionComponent } from "react";

interface ToggleSwitchProps {
  id: string;
  name: string;
  checked: boolean;
  onChange?: (payload: { id: string; name: string; checked: boolean }) => void;
  alwaysActive?: boolean;
}

export const CookieBannerToggleSwitch: FunctionComponent<ToggleSwitchProps> = ({
  id,
  name,
  checked,
  onChange,
  alwaysActive = false,
}) => {
  const handleToggle = () => {
    if (alwaysActive) return; // Prevent toggling if alwaysActive is true
    onChange?.({ id, name, checked: !checked });
  };

  /* Outer association uses <label htmlFor={id}> in CookiesBanner so the option text is a visible label. */
  return (
    <div
      className={`inline-flex shrink-0 items-center ${
        alwaysActive ? "cursor-not-allowed pointer-events-none" : "cursor-pointer"
      }`}
    >
      <input
        type="checkbox"
        checked={alwaysActive ? true : checked}
        onChange={handleToggle}
        className="sr-only"
        aria-checked={alwaysActive ? true : checked}
        disabled={alwaysActive}
        id={id}
        name={name}
      />
      <div
        className={`relative w-12 h-6 rounded-full transition-colors duration-200 ease-in-out ${
          checked
            ? "bg-primary-600 hover:bg-primary-700 active:bg-primary-800"
            : "bg-neutral-400 hover:bg-neutral-500 active:bg-neutral-600"
        } ${alwaysActive ? "opacity-60 bg-neutral-400" : ""}`}
      >
        <div
          className={`absolute top-1/2 -translate-y-1/2 left-1 w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-200 ease-in-out ${
            alwaysActive || checked ? "translate-x-6" : "translate-x-0"
          }`}
        />
      </div>
    </div>
  );
};
